import PropTypes from 'prop-types';
import { trans, useSoyuzClientConfig } from '@spotahome/soyuz/client';
import { PrivateLandlord, useCityName } from '@spotahome/ui-library';
import { Mediator } from '@spotahome/soyuz-mediator';
import { useInView } from 'react-intersection-observer';

import { OPEN_PHOTO_SLIDER_SECTION } from '@spotahome/marketplace-common/src/channels';

import { ListingSectionObservable } from '../ListingSection';

import './ListingLocation.scss';

const getStaticMapUrl = ({ lat, lng, zoom = 10, apiKey }) =>
  `https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&scale=1&zoom=${zoom}&format=png&maptype=roadmap&size=640x360&key=${apiKey}`;

const ListingLocation = ({ listing }) => {
  const { googleMapsApiKey } = useSoyuzClientConfig();
  const cityName = useCityName(listing.cityId);
  const [lng, lat] = listing.coords;
  const zoom = 14;

  const { ref, inView } = useInView({ triggerOnce: true, rootMargin: '300px' });

  const handleOpenMap = () => {
    Mediator.publish(OPEN_PHOTO_SLIDER_SECTION, 'map');
  };

  const mapUrl = inView
    ? getStaticMapUrl({ lat, lng, zoom, apiKey: googleMapsApiKey })
    : null;

  return (
    <ListingSectionObservable section="location" className="listing-location">
      <hr className="listing-location__divider" />
      <h2 className="listing-location__title">
        {trans('listing.location.title')}
      </h2>
      <p className="listing-location__city">
        {cityName}, {listing.area}
      </p>
      <p className="listing-location__address">
        {trans('listing.location.exact_address')}
      </p>
      <button
        ref={ref}
        className="listing-location__map-button"
        onClick={handleOpenMap}
        type="button"
        aria-label={cityName}
      >
        {mapUrl && (
          <>
            <img
              className="listing-location__map-image"
              src={mapUrl}
              alt={cityName}
            />
            <div className="listing-location__map-overlay" />
            <div className="listing-location__map-icon">
              <PrivateLandlord />
            </div>
          </>
        )}
      </button>
    </ListingSectionObservable>
  );
};

ListingLocation.propTypes = {
  listing: PropTypes.object.isRequired
};

export default ListingLocation;
